import { API_URL } from "../../config";

export const uploadImage = async (file: File): Promise<string | null> => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const baseUrl = process.env.REACT_APP_API_URL;
      
      const response = await fetch(`${baseUrl}/utility/upload`, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token') || ''}`, 
        },
      });
  
      if (response.ok) {
        const responseData = await response.json();
        console.log(responseData);
        return responseData.data; 
      } else {
        throw new Error('Error uploading image');
      }
    } catch (error) {
      throw new Error('Error uploading image');
    }
  };

  export const uploadAttachments = async (file: File): Promise<string | null> => {
    try {
      const formData = new FormData();
      formData.append("file", file);
  
      const baseUrl = process.env.REACT_APP_API_URL;
  
      const response = await fetch(`${API_URL}/utility/attachments/upload`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        },
      });
  
      if (response.ok) {
        const responseData = await response.json();
        console.log(responseData);
        return responseData.data;
      } else {
        throw new Error("Error uploading image");
      }
    } catch (error) {
      throw new Error("Error uploading image");
    }
  };
  
  export const uploadMultipleFiles = async (files: File[]): Promise<string[]> => {
    const results: string[] = [];
  
    for (const file of files) {
      const uploadedPath = await uploadAttachments(file);
      if (uploadedPath) {
        results.push(uploadedPath);
      }
    }
  
    return results;
  };
  
  